import { CheckboxProps } from '@cloudscape-design/components/checkbox';
import { CollectionPreferencesProps } from '@cloudscape-design/components/collection-preferences';
import { InputProps } from '@cloudscape-design/components/input';
import {
  AttributeEditorProps,
  MultiselectProps,
  NonCancelableCustomEvent,
  TokenGroupProps,
  WizardProps,
} from '@cloudscape-design/components';
import { SelectProps } from '@cloudscape-design/components/select';
import { TableProps } from '@cloudscape-design/components/table';

export type AttributeRemoveEvent =
  NonCancelableCustomEvent<AttributeEditorProps.RemoveButtonClickDetail>;
export type CheckboxChangeEvent =
  NonCancelableCustomEvent<CheckboxProps.ChangeDetail>;
export type CollectionPreferenceEvent =
  NonCancelableCustomEvent<CollectionPreferencesProps.Preferences>;
export type InputChangeEvent =
  NonCancelableCustomEvent<InputProps.ChangeDetail>;
export type MultiselectChangeEvent =
  NonCancelableCustomEvent<MultiselectProps.MultiselectChangeDetail>;
export type NavigateDetailEvent =
  NonCancelableCustomEvent<WizardProps.NavigateDetail>;
export type PreferenceConfirmEvent =
  NonCancelableCustomEvent<CollectionPreferencesProps.Preferences>;
export type SelectChangeEvent =
  NonCancelableCustomEvent<SelectProps.ChangeDetail>;
export type SelectLoadEvent =
  NonCancelableCustomEvent<SelectProps.LoadItemsDetail>;
export type TableChangeEvent<T> = NonCancelableCustomEvent<
  TableProps.SelectionChangeDetail<T>
>;
export type TokenGroupsDismissEvent =
  NonCancelableCustomEvent<TokenGroupProps.DismissDetail>;
